<template>
  <div>
    <component v-if="!loading" v-bind:is="view"></component>
  </div>
</template>

<script>
import register from "./Register.vue";
import sendcertificate from "./SendCertificate.vue";
import viewcertificate from "./Viewcertificate.vue";
import SendMessage from "./SendMessage.vue";
import claim from "./Claim.vue";
import InsuranceRegister from "./insurance/InsuranceRegister.vue";
import DownloadTaxCert from "./DownloadTaxCert.vue";
import queryString from "query-string";
// @ is an alias to /src

export default {
  name: "home",
  data() {
    return {
      pageid: "",
      loading: true,
      testmode: false,
    };
  },
  components: {
    register,
    sendcertificate,
    viewcertificate,
    InsuranceRegister,
    SendMessage,
    claim,
    DownloadTaxCert,
  },
  async mounted() {
    this.queryinit();
    if (this.testmode) {
      this.loading = false;
      this.$store.state.profile.userId = "Uc40ec9623e7a01d8293897a3d5dac51c";
    } else {
      await this.initializeLiff(this.$store.state.liffId);
    }
  },
  methods: {
    async initializeLiff(myLiffId) {
      var vm = this;
      var redirectUri = window.location.href;
      try {
        await this.$liff.init({
          liffId: myLiffId,
        });
        console.log("liff login");
        if (await this.$liff.isLoggedIn()) {
          console.log("liff login true");
          this.$store.state.profile = await this.$liff.getProfile();
          vm.loading = false;
        } else {
          console.log("liff login false");
          await this.$liff.login({ redirectUri });
        }
      } catch (error) {
        // alert(error.message);
      }
    },
    queryinit() {
      var vm = this;
      vm.$store.state.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;

      if (vm.query.pageid) vm.pageid = vm.query.pageid;
    },
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.query.view;
    },
  },
};
</script>
